import { useFirestore } from "@/hooks/firestore/core/useFirestore";
import { publicProfile } from "@/hooks/firestore/models/publicProfile";
import type { Always } from "types/utilities";

const usePublicProfile = (userId?: string) => {
  const { data, isLoading, error } = useFirestore(
    userId ? `/publicUserProfiles/${userId}` : null,
    publicProfile,
  );

  return {
    profile: data,
    isLoading,
    error,
  };
};

type PublicProfile = Always<ReturnType<typeof usePublicProfile>["profile"]>;

export { usePublicProfile };
export type { PublicProfile };
